import { render } from "./distributor_target.vue?vue&type=template&id=001a31f9"
import script from "./distributor_target.vue?vue&type=script&lang=js"
export * from "./distributor_target.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__